import styled from "styled-components";
import Heading from "./../../atoms/Heading";
import { ReactComponent as BoxEmpty } from "./../../atoms/icons/box-empty.svg";

export const Wrap = styled.div`
  width: 100%;

  &.active {
    height: auto !important;

    @media (max-width: 989px) {
      .inner-sidebar {
        height: auto;
      }
    }
  }

  @media (min-width: 990px) {
    position: sticky;
    top: 122px;
    width: 352px;
    margin-top: 15px;
    padding: 24px;
    padding-top: 20px;
    padding-bottom: 0;
    border-radius: 4px;
    border: 1px solid #e6e6e6;
  }

  &.active h1 {
    margin-bottom: 0;
    border-bottom: none;
  }

  @media (min-width: 990px) {
    &.account {
      top: 80px;
    }
  }
`;

export const Inner = styled.div`
  position: relative;
  z-index: 3;
  margin: 0 -24px;
  padding: 0 24px;
  background: #fff;

  @media (max-width: 989px) {
    position: fixed;
    top: 0;
    z-index: 7;
    width: 100%;
    height: 140px;
    background: #fff;

    h1 + div {
      border-bottom: none;
    }
  }

  &.sticky {
    position: fixed;
    top: 0;
    width: 100%;
    background: #fff;

    h1 + div {
      border-bottom: none;
    }
  }
`;

export const Overlay = styled.div`
  display: block;
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
`;

export const SidebarHeading = styled(Heading)`
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 10px;
  padding: 0;
  padding-top: 24px;
  padding-bottom: 10px;
  font-size: 18px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: -0.5px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);

  svg {
    position: absolute;
    right: 0;
  }

  @media (min-width: 990px) {
    margin-bottom: 0;
    padding-top: 0;
    padding-bottom: 6px;
    font-size: 20px;

    svg,
    button {
      display: none;
    }
  }
`;

export const BackButton = styled.a`
  display: block;
  width: 24px;
  height: 24px;
  border: none;
  background: none;
  padding: 0;
  outline: none;
  cursor: pointer;
  user-select: none;
  outline: none;
  box-shadow: none;
  margin-right: 4px;
  transform: translate(-5px, 0);

  &:focus,
  &:hover,
  &:active {
    outline: none;
    box-shadow: none;
  }

  svg {
    position: static;
  }

  svg path {
    fill: var(--color-primary);
  }

  @media (min-width: 990px) {
    display: none;
  }
`;

export const Alert = styled.span`
  position: absolute;
  right: 2px;
  top: 16px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: var(--color-primary);
  border: 1px solid #fff;
  font-size: 10px;
  line-height: 12px;
  color: #fff;
  text-align: center;

  @media (min-width: 990px) {
    display: none;
  }
`;

export const MenuButton = styled.button`
  position: absolute;
  display: block;
  top: 19px;
  right: 0;
  border: none;
  background: #fff;
  padding: 0;
  outline: none;
  cursor: pointer;
  user-select: none;
  outline: none;
  box-shadow: none;

  &:focus,
  &:hover,
  &:active {
    outline: none;
    box-shadow: none;
  }

  svg {
    position: relative;
  }

  svg path {
    fill: var(--color-secondary);
  }
`;

export const EmptyBox = styled(BoxEmpty)`
  filter: grayscale(1);
`;